<script>
export default {
  name: 'BlankLayout',
}
</script>

<template>
  <slot />
</template>
